import type { SxProps, Theme } from "@mui/material/styles";

export const root: SxProps<Theme> = {
  display: "flex",
  alignItems: { xs: "stretch", sm: "center" },
  justifyContent: "space-between",
  flexWrap: "wrap",
  gap: 2,
};

export const textBlock: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  gap: 0.625,
};

export const title: SxProps<Theme> = {
  fontWeight: 700,
  fontSize: { xs: "1.25rem", sm: "1.5rem" },
  color: "text.primary",
};

export const subtitle: SxProps<Theme> = {
  fontSize: "0.8125rem",
  color: "text.secondary",
};

export const statHighlight: SxProps<Theme> = {
  fontWeight: 700,
  color: "text.primary",
  display: "inline",
};

export const statWarning: SxProps<Theme> = {
  fontWeight: 700,
  color: "warning.main",
  display: "inline",
};

export const datePill: SxProps<Theme> = (theme) => ({
  display: "inline-flex",
  alignItems: "center",
  gap: 1,
  bgcolor: "background.paper",
  border: `1px solid ${theme.palette.divider}`,
  px: 2.25,
  py: 1.25,
  borderRadius: 15,
  fontSize: "0.8125rem",
  color: "text.secondary",
});
